import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import th from './locales/th.json';
import vi from './locales/vi.json';
import my from './locales/my.json';
import lo from './locales/lo.json';
import zh from './locales/zh.json';

const resources = {
  en: { translation: en },
  th: { translation: th },
  vi: { translation: vi },
  my: { translation: my },
  lo: { translation: lo },
  zh: { translation: zh },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
